import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/compat/router";

import { openMiniCart } from "@/redux/actions/addToCartAction";
import { openAccountSidebar, passMsgToAccountSidebar} from "@/redux/actions/loggedInUser";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";

import ReactSidebar from "@/components/common/ReactSidebar";
import Wishlist from "../Wishlist";
import MiniBasket from "@/components/Basket/MiniBasket";
import AccountSideBar from "@/components/Header/Account";
import Bag from "../Bag";
import OlivelaLogo from "@/components/common/OlivelaLogo";
import Search from "../Search";
import { MenuBuilder } from "@/components/BuilderIO/Menu/Menu.builder";

import styles from "../Header.module.scss";
import Link from "next/link";
import WishlistComp from "@/components/Wishlist";
import { bodyOverflow } from "@/helpers/userHelpers";
import AccountIcon from "@/components/Logos/Account";
import { getCookie } from "cookies-next";
import { viewCart } from "@/components/common/Nosto";
import { errorMessages } from "@/utils/constants";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

export default function DesktopMainHeader(props) {
  const dispatch = useDispatch();
  const router = useRouter();
  const basketSidebarOpen = useSelector((state) => state.click.open_mini_cart);
  const [myAccount, setMyAccount] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const isDesktopLarge = useMediaQuery("(min-width: 991px)");

  if (basketSidebarOpen && isDesktop) {
    viewCart();
  }
  const userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const [userIcon, setUserIcon] = useState("images/Icons/User.svg");
  useEffect(() => {
    if (userLoggedIn) {
      setUserIcon("images/Icons/User-Signed-In 2.svg");
      // if the server path is related to account show the drawer, for other pages do not show the drawer after login
      if(router?.asPath?.includes("/account")){
        //OS-3879: check if its checkout login. If yes then don't open drawer after login
        if(!userLoggedIn && !router?.asPath?.includes("/account/login") && !(document?.referrer?.includes("qacheckout.olivela.com") || document?.referrer?.includes("checkout.olivela.com"))) {
          dispatch(openAccountSidebar(true));
        }
      }
    }
  }, [userLoggedIn]);

  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );

  const handleAccountSidebar = (e) => {
    dispatch(openAccountSidebar(e));
  };

  const { selectedIcon, selectIcon } = props;
  // const [accountSidebarOpen, setAccountSidebarOpen] = useState(false);
  let { pages = [] } = router.query;
  // get {drawer_section} value either from [...pages] or directly from the url
  const drawer_section = pages && pages.length ? pages[0] : router.pathname.split("/")[1];
  const drawer_tab = pages && pages.length > 1 ? pages[1] : "";
  const drawer_order_id = pages && pages.length > 2 ? pages[2] : "";
  useEffect(() => {
    if (window.innerWidth >= 768) {
      if ( drawer_section === "account" || drawer_section === "login" || drawer_section === "register" || drawer_section === "activate-account" ) {
        let shouldOpen = true
        if( !shouldOpen ) return

        if (window.innerWidth <= 990) {
          document.querySelector(".header_account_icon")?.click();
        } else {
          handleAccountSidebar(true);
        }
      }
    }

  }, [router]);
  const handleBasketSidebar = (e) => {
    if (selectIcon !== "bag-icon") {
      selectIcon("bag-icon");
    } else {
      selectIcon("");
    }
    // sidebar drawer should not open on clicked
    dispatch(openMiniCart(false));
  };

  const handleWishlistSidebar = (e) => {
    dispatch(openWishlistSidebar(e));
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      if (basketSidebarOpen || wishlistSidebarOpen || accountSidebarOpen) {
        bodyOverflow;
      } else {
        bodyOverflow(false);
      }
    }
  }, [basketSidebarOpen, wishlistSidebarOpen, accountSidebarOpen]);

  const isSuperbrandHeroPresent = useSelector(
    (state) => state.header.isSuperbrandHeroPresent
  );

  const submenuToggle=useSelector(
    (state) => state.header.isSubmenuVisible
  );
  return (
    <section className={`${styles.logo_section}`}>
      <div className="container-fluid mw-1440">
        <div className="row">
          <div className="grid-md-12">
            <div className={`${styles.shop_menu_small_header}`}>
              {props.topLinks}
            </div>
            <div className={`text-center ${styles.logo_wrapper}`}>
                <a id="olivela-logo" href="/" tabIndex={-1}>
                  <OlivelaLogo
                    className={`${styles.main_logo_img}`}
                    superbrandHeroPresent={isSuperbrandHeroPresent && !props.scroll && !submenuToggle}
                    tabIndex={true}
                  />
                </a>
              <span className={`${styles.icons_wrapper}`}>
                <ul id="desktop-icons" className={`${styles.icons_wrapper_ul}`}>
                  <li
                    id="search-icon-desktop"
                    className={`position_relative desktop_header_icon desktop-search ${styles.icons_wrapper_li} ${
                      selectedIcon == "search"
                        ? `selected ${styles.selected}`
                        : ""
                    }`}
                    onClick={() => {
                      selectIcon("search");
                      props.handleSearchClick();
                    }}
                    tabIndex={0}
                  >
                    <Search className="search-header-desktop" isSuperbrandHeroPresent={isSuperbrandHeroPresent && !props.scroll && !submenuToggle} />
                    <span className={`${styles.icons_text} search-header-desktop xx-small-md ${isSuperbrandHeroPresent && !props.scroll && !submenuToggle?"light-text":""} `}>Search</span>
                  </li>
                  <li
                    id="fav-icon-desktop"
                    className={`position_relative desktop_header_icon ${styles.icons_wrapper_li} ${
                      styles["fav-icon"]
                    } ${selectedIcon == "wishlist" ? "selected" : ""}`}
                    onClick={() =>{ selectIcon("wishlist")}}
                  >
                    <ReactSidebar
                      childSlider={true}
                      parentSlider={accountSidebarOpen}
                      mainContent={<div tabIndex={0} className="fav-desktop"><Wishlist className="fav-header-desktop" isSuper={isSuperbrandHeroPresent && !props.scroll && !submenuToggle} />
                      <span className={`${styles.icons_text} xx-small-md wishlist fav-header-desktop ${isSuperbrandHeroPresent && !props.scroll && !submenuToggle?"light-text":""}`}>Wishlist</span></div>
                      }
                      sidebarContent={<WishlistComp />}
                      handleSidebar={handleWishlistSidebar}
                      sidebarOpen={wishlistSidebarOpen}
                      rootClassName={"basket_slidecart"}
                      styles={{
                        root: {
                          position: "relative",
                          height: 30,
                          width: 80,
                        },
                        sidebar: {
                          position: "fixed",
                          overflow: "auto",
                        },
                      }}
                      pullRight={true}
                    />
                  </li>
                  {isDesktopLarge && (<li
                    id="basket-icon-desktop"
                    className={`position_relative desktop_header_icon desk-basket ${styles.icons_wrapper_li} ${
                      selectedIcon === "bag-icon" ? "selected" : ""
                    } ${styles["bag-icon"]}`}
                  >
                    <ReactSidebar
                      mainContent={<Bag classProp="minibag-desktop" isSuper={isSuperbrandHeroPresent && !props.scroll && !submenuToggle} />}
                      sidebarContent={<MiniBasket isMobile={false} />}
                      handleSidebar={handleBasketSidebar}
                      sidebarOpen={basketSidebarOpen}
                      rootClassName={"basket_slidecart"}
                      selectedIcon={selectedIcon}
                      styles={{
                        root: {
                          position: "relative",
                          height: 30,
                          width: 40,
                        },
                        sidebar: {
                          position: "fixed",
                          overflow: "auto",
                        },
                      }}
                      pullRight={true}
                    />
                  </li>)}
                </ul>
              </span>
            </div>
          </div>
        </div>
      </div>
     {/* <MainMenu />  component on homepage, Same componet is used for desktop & mobile      */}
      {!props.scroll && <MenuBuilder />}
    </section>
  );
}
